/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cus_SubmitInputs */

const en_cus_submit = /** @type {(inputs: Cus_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit`)
};

const ja_cus_submit = /** @type {(inputs: Cus_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信`)
};

const fr_cus_submit = /** @type {(inputs: Cus_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

const de_cus_submit = /** @type {(inputs: Cus_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

/**
* | output |
* | --- |
* | "Submit" |
*
* @param {Cus_SubmitInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cus_submit = /** @type {((inputs?: Cus_SubmitInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cus_SubmitInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cus_submit(inputs)
	if (locale === "ja") return ja_cus_submit(inputs)
	if (locale === "fr") return fr_cus_submit(inputs)
	return de_cus_submit(inputs)
});